module.exports = __webpack_public_path__ + "src/assets/img/Unused.060e8e86.png";